<div class="image-upload-container">
  <!-- Label and help text -->
  <label class="form-label">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>
  <div *ngIf="helpText" class="help-text">{{ helpText }}</div>

  <input type="file" class="file-input-hidden" #fileUpload [accept]="getAcceptAttribute()"
    (change)="fileChangeEvent($event)" [required]="required" />

  <!-- Error message -->
  <div *ngIf="error" class="error-message">
    <span class="material-icons">error</span>
    {{ error }}
  </div>

  <!-- Existing image display -->
  <div *ngIf="imageUrl && !isCropperReady" class="existing-image-container">
    <img [src]="imageUrl" [alt]="label" class="existing-image" />
    <div class="image-actions">
      <button type="button" class="image-action-button btn-save" (click)="downloadImage()" title="Download image">
        <span class="btn-save-text">Download</span>
      </button>
      <button type="button" class="image-action-button btn" (click)="uploadNewImage()" title="Upload a new image">
        <span class="btn-text">Upload New</span>
      </button>
      <button type="button" class="image-action-button btn-close" (click)="deleteImage()">
        <span class="btn-save-text">Delete</span>
      </button>
    </div>
  </div>

  <!-- File selection area (shown when no image is being cropped) -->
  <div *ngIf="!isCropperReady && !uploading && !imageUrl" class="file-selection-area">
    <label class="file-input-label" (click)="fileUpload.click()" (dragover)="onDragOver($event)"
      (drop)="onDrop($event)">
      <div class="file-input-content">
        <span class="material-icons upload-icon">cloud_upload</span>
        <span class="file-input-text">
          {{ selectedFileName || 'Click to upload or drag and drop' }}
        </span>
        <span class="file-input-hint">
          Accepted formats: {{ getFormattedFileTypes() }}
        </span>
        <span class="file-input-hint">
          Max size: {{ getFormattedMaxFileSize() }}MB
        </span>
      </div>
    </label>
  </div>

  <!-- Image cropper -->
  <div *ngIf="imageChangedEvent" class="cropper-container">
    <div class="cropper-title">{{ label }}</div>
    <p class="cropper-instruction">Crop the image to fit the desired area</p>

    <image-cropper class="image-cropper" [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="shouldMaintainAspectRatio()" [aspectRatio]="getAspectRatio()" [format]="outputFormat"
      [resizeToWidth]="imageWidth" (imageCropped)="imageCropped($event)" (cropperReady)="onCropperReady()"
      (loadImageFailed)="loadImageFailed()"></image-cropper>

    <p class="cropper-instruction mt-2">Preview</p>
    <div class="preview-container">
      <img *ngIf="croppedImage" [src]="croppedImage" class="preview-image" [alt]="'Preview of ' + label" />
    </div>

    <div class="cropper-actions">
      <button type="button" class="btn-cancel" (click)="resetCropper()">
        <span class="material-icons">close</span>
        Cancel
      </button>
      <button type="button" class="btn-save" (click)="uploadImage()" [disabled]="!isCropperReady || uploading">
        <span class="material-icons">save</span>
        Save Image
      </button>
    </div>
  </div>

  <!-- Upload progress -->
  <div *ngIf="uploading" class="upload-progress-container">
    <div class="progress-bar">
      <div class="progress-fill" [style.width]="getProgressBarWidth()"></div>
    </div>
    <p class="progress-text">Uploading... {{ getUploadProgressPercent() }}</p>
  </div>
</div>